import { Fragment } from 'react';
import PropTypes from 'prop-types';
import HostGroupSummary from './host-group-summary';
import HostUserSummary from './host-user-summary';

const HostSummaries = ({ event }) => {
  const { hostType, user, group } = event;
  return (
    <Fragment>
      {hostType === 'User' && user && (
        <HostUserSummary user={user} />
      )}
      {group && (
        <HostGroupSummary group={group} />
      )}
    </Fragment>
  );
}

HostSummaries.propTypes = {
  event: PropTypes.object.isRequired,
};

export default HostSummaries;
